@use "./Header.module.scss" as *;

.panel {
    position: fixed;
    top: $main-nav-height;
    left: 0;
    right: 0;
    box-shadow: 0 4px 8px rgb(from var(--color-contrast) r g b / 12%);
    max-height: calc(100dvh - #{$main-nav-height});
    overflow-y: auto;
    padding-block: var(--spacer-40);
    z-index: 13;
}
